// extracted by mini-css-extract-plugin
export default {"list":"DesktopNavigationList_list__qm+0-"};